module.exports = __webpack_public_path__ + "static/media/vertex_figure_polytope_52_3_3.82d4f9c7.png";